import React from "react";
import classes from "./styles.module.scss";
import { Link } from "react-router-dom";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import logo from "../../assets/images/icons/logo.svg";
import Copyright from "../copyright";
import { useTranslation } from "../../context/language";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <footer className={classes.footer_container}>
        <div className={classes.footer_content}>
          {/* Column 1: Logo & Text */}
          <div className={classes.footer_col_brand}>
            <div className={classes.brand_header}>
              <div className={classes.logo_box}>
                <img src={logo} alt="Gyandeep Logo" />
              </div>
              <div className={classes.brand_text}>
                <h2 className={classes.brand_title}>Gyandeep</h2>
                <p className={classes.brand_subtitle}>
                  {t("hero.rightToEducation")}
                </p>
              </div>
            </div>
            <div className={classes.brand_description}>
              <h3 className={classes.building_future_title}>
                {t("hero.buildingTheFuture")}
              </h3>
              <p className={classes.building_future_text}>
                {t("hero.buildingTheFutureDesc")}
              </p>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className={classes.footer_col}>
            <h3 className={classes.col_title}>{t("footer.quickLinks")}</h3>
            <ul className={classes.link_list}>
              <li>
                <Link to="/instructions">{t("footer.instructions")}</Link>
              </li>
              <li>
                <Link to="/registration-school-details">
                  {t("footer.listOfSchool")}
                </Link>
              </li>
              <li>
                <Link to="/registration-application">
                  {t("footer.getApplication")}
                </Link>
              </li>
              <li>
                <Link to="/general-notifications">
                  {t("footer.generalNotifications")}
                </Link>
              </li>
              <li>
                <Link to="/randomization-notifications">
                  {t("footer.randomizationNotifications")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Government Links */}
          <div className={classes.footer_col}>
            <h3 className={classes.col_title}>{t("footer.governmentLinks")}</h3>
            <ul className={classes.link_list}>
              <li>
                <Link
                  to="http://edu-online.bihar.gov.in/RtiReg/index.Html"
                  target="_blank"
                >
                  {t("footer.eSambandhanPortal")}
                </Link>
              </li>
              {/* <li>
                <Link to="#">Terms of Use</Link>
              </li>
              <li>
                <Link to="#">Sitemap</Link>
              </li>
              <li>
                <Link to="#">RTI</Link>
              </li> */}
            </ul>
          </div>

          {/* Column 4: Contact Us */}
          <div className={classes.footer_col}>
            <h3 className={classes.col_title}>{t("footer.contactUs")}</h3>
            <ul className={classes.contact_list}>
              {/* <li>
                <LocationOnOutlinedIcon className={classes.contact_icon} />
                <span>xyz</span>
              </li> */}
              <li>
                <PhoneOutlinedIcon className={classes.contact_icon} />
                <span>18003454417 / 14417</span>
              </li>
              <li>
                <MailOutlineIcon className={classes.contact_icon} />
                <Link to="mailto:rtebiharhelp@gmail.com">
                  rtebiharhelp@gmail.com
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <Copyright />
    </>
  );
};

export default Footer;
